module.exports = __webpack_public_path__ + "img/card_240750780.ceee8def.jpg";